import { Controller } from '@hotwired/stimulus'
import Inputmask from 'inputmask'

// Connects to data-controller="input-mask"
export default class extends Controller<HTMLElement> {
  static values = {
    mask: String,
    options: Object,
  }

  declare maskValue: string
  declare optionsValue: object

  connect (): void {
    Inputmask(this.maskValue, this.optionsValue).mask(this.element)
  }
}
